import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight: '380px',
    overflowY: 'auto',
    '@media (max-width: 959px)': {
      //mobile botom nav bar height
      maxHeight: '100%'
    }
  },

  permissionsList: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    paddingLeft: '1.5rem'
  },

  permission: {
    paddingBottom: '1rem',
    display: 'flex',
    flexDirection: 'column'
  },

  checkBox: {
    marginBottom: '0',
    alignItems: 'center'
  },

  groups: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: '1rem'
  },

  groupName: {
    paddingBottom: '1rem',
    fontSize: theme.size.sm
  },

  details: {
    color: theme.palette.textLightFaded,
    paddingLeft: '1.75rem',
    cursor: 'default'
  },

  defaultClass: {
    cursor: 'default'
  },

  lockedOption: {
    display: 'flex'
  },

  icon: {
    width: '0.75rem',
    height: '0.75rem',
    color: theme.palette.primary.main,
    marginRight: '0.5rem'
  }
}))

export default useStyles
